import { readChoice, readJson, rememberValue, userKey } from "../../browserMemory.js";
import { TIMELINE_STAGES, type TimelineStage } from "./timelineModel.js";

/**
 * MERKEN DER ZEITACHSE JE BENUTZER (Spec Plan-Ansicht S17, `browserMemory.ts` mit `userKey`): die gewählte Stufe und die
 * zugeklappten Gruppen (`team:<id>`, `team:none`, ausdrücklich offen `!team:<id>`). Nur Kennungen, keine Namen
 * (Review 12). Anker, freies Fenster, aufgeklappte Eltern-Balken und Auswahl werden nicht gemerkt.
 */

export const TIMELINE_STAGE_KEY = "ki-tickets-timeline-stage";
export const TIMELINE_COLLAPSED_KEY = "ki-tickets-timeline-collapsed";

/** Die gemerkte Stufe; Vorgabe Woche, am Telefon Tag. */
export function readStage(userId: string | undefined, phone: boolean): TimelineStage {
  return readChoice(userKey(TIMELINE_STAGE_KEY, userId), TIMELINE_STAGES, phone ? "DAY" : "WEEK");
}

export function rememberStage(userId: string | undefined, s: TimelineStage): void {
  rememberValue(userKey(TIMELINE_STAGE_KEY, userId), s);
}

/** Die zugeklappten Gruppen; nur Zeichenketten einer Liste zählen, alles andere fällt weg. Unbekannte Gruppen
 *  übergeht das Modell. */
export function readCollapsed(userId: string | undefined): Set<string> {
  const value = readJson(userKey(TIMELINE_COLLAPSED_KEY, userId));
  return new Set(Array.isArray(value) ? value.filter((x): x is string => typeof x === "string") : []);
}

export function rememberCollapsed(userId: string | undefined, ids: ReadonlySet<string>): void {
  rememberValue(userKey(TIMELINE_COLLAPSED_KEY, userId), JSON.stringify([...ids]));
}
